export const namespace = 'canalplus.block.maverick.jaquettes.tabs';
export { default as Component } from './components/Jaquettes';
export { default as propsFormatter } from './propsFormatter';
